import { getEnumValueColorAndIcon, EnumOptionLite } from '~/components/shared/enum-options'
import { EnumChip } from '~/components/shared/EnumChip'

interface EnumArrayTableCellProps {
  value: string[]
  enumSetOptions?: EnumOptionLite[]
}

/**
 * Renders table cell for a column of type ARRAY with inner type Enum
 */
export function EnumArrayTableCell({ value, enumSetOptions }: EnumArrayTableCellProps) {
  return (
    <div className="flex flex-row items-center gap-2 overflow-hidden">
      {value.map((selection) => {
        const { color, iconName } = getEnumValueColorAndIcon(selection, enumSetOptions)
        return (
          <EnumChip
            key={selection}
            className="shrink-0"
            color={color}
            iconName={iconName}
            label={selection}
          />
        )
      })}
    </div>
  )
}
